import createLucideIcon from '../createLucideIcon';

const Disc2 = createLucideIcon('Disc2', [
  ['circle', { cx: '12', cy: '12', r: '4', key: '4exip2' }],
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['line', { x1: '12', y1: '12', x2: '12', y2: '12.01', key: '9j0fb8' }],
]);

export default Disc2;
